import { findUrl } from '@/utils/string/findUrl'
import { emojiToHtmlReplacer, getEmojiRegexp } from '@/utils/emojiHelpers'
import { getTagsRegexp } from '@/services/forms/tmTiptap/utils/getTagsRegexp'
import {
  createLinkAContent,
  createLinkSpanContent,
  createParagraphContent,
  createTagContent,
} from '@/services/forms/tmTiptap/utils/createContent'

export const createContentFromTemplate = (templateText: string, replaceLinksWithSpan = true) =>
  templateText
    .split(/\n/)
    .map((line, i) => {
      // Find all links in the line and replace them with their HTML equivalent
      const links = findUrl(line)
      links.forEach((link) => {
        line = line.replace(
          link.value,
          replaceLinksWithSpan ? createLinkSpanContent(link.value) : createLinkAContent(link.value),
        )
      })

      // Split the text into lines and map each line to HTML content
      // Replace all tags with their HTML equivalent
      line = line.replace(getTagsRegexp('g'), (_: string, tag: string) => createTagContent(tag))

      // Replace all emojis with their HTML equivalent
      line = line.replace(getEmojiRegexp(false, true), (_: string, emoji: string) => emojiToHtmlReplacer(emoji))

      // Wrap the line in a paragraph tag
      // for the first line the editor automatically creates a paragraph
      return i ? createParagraphContent(line) : line
    })
    .join('')
